import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import store, {persistor} from './store/appStore';
import Views from './routes/RoutesRendering';
import './App.css';
import {ThemeCustomization} from './themes';
import {ApolloWrapperProvider, SnackProviderConfig} from 'configs';
import {GlobalNotificationListener} from 'components/Notification';

const testingBeforePresistence = () => {};
const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={'loading'} persistor={persistor as any} onBeforeLift={testingBeforePresistence}>
                <SnackProviderConfig>
                    <ApolloWrapperProvider>
                        <BrowserRouter>
                            <ThemeCustomization>
                                <GlobalNotificationListener />
                                <Views />
                            </ThemeCustomization>
                        </BrowserRouter>
                    </ApolloWrapperProvider>
                </SnackProviderConfig>
            </PersistGate>
        </Provider>
    );
};

export default App;
